export default __webpack_public_path__ + "static/media/buccaneer.ce92e3c4.png";